<template>
  <div class="OrderDetail wide-container" :class="{ 'is-embedded': embedded }">
    <!-- 1. 骨架屏加载态 -->
    <div class="detail-skeleton" v-if="detailLoading">
      <div class="skeleton-shimmer"></div>
      <div class="sk-header-card"></div>
      <div class="sk-info-grid">
        <div class="sk-card"></div>
        <div class="sk-card"></div>
      </div>
      <div class="sk-table-card"></div>
    </div>

    <!-- 2. 真实订单详情内容 -->
    <div class="detail-content fade-in" v-else>
      <!-- 顶部订单概览操作条 -->
      <div class="order-summary-header-card">
        <div class="header-main-info">
          <div class="title-row">
            <span class="page-title">{{ type ? (type === 'returnGoods' ? '申请退货' : '申请换货') : '订单详情' }}</span>
            <div class="order-no-pill">
              <span class="label">订单号：</span>
              <strong class="no font-mono">{{ data['5rh34ajk852uufsx'] }}</strong>
              <button type="button" class="copy-btn" @click="copyToClipboard" title="复制订单号">
                <i class="el-icon-document-copy"></i>
              </button>
            </div>
            <span class="contract-badge">
              <i class="el-icon-circle-check"></i> 框架协议入库品 · 支持13%专票
            </span>
          </div>
          <div class="sub-row" v-if="data.l0u3cwjsdrbnhuth">
            <span>下单时间：{{ data.l0u3cwjsdrbnhuth }}</span>
          </div>
        </div>

        <div class="header-action-zone">
          <button v-if="!embedded" class="back-link-btn" type="button" @click="$router.go(-1)">
            <i class="el-icon-back"></i> 返回列表
          </button>
        </div>
      </div>

      <!-- 仅普通详情展示：收货信息与部门信息双栏 -->
      <div class="info-cards-grid" v-if="!type">
        <!-- 收货信息卡片 -->
        <div class="info-card">
          <div class="card-header">
            <span class="accent-bar"></span>
            <h3 class="card-title">收货配送信息</h3>
          </div>
          <div class="card-body">
            <div class="info-line">
              <span class="info-label">收货联系人：</span>
              <span class="info-val bold">
                {{
                  data['7gohkizhpuyntjkg'] && data['7gohkizhpuyntjkg'].length > 0
                    ? data['7gohkizhpuyntjkg'][0].value
                    : '-'
                }}
              </span>
            </div>
            <div class="info-line">
              <span class="info-label">联系电话：</span>
              <span class="info-val font-mono">{{ data['9hsjp14robmaesii'] || '-' }}</span>
            </div>
            <div class="info-line">
              <span class="info-label">收货地址：</span>
              <span class="info-val">
                {{
                  data['3ysepdqjbyoaa9vv'] && data['3ysepdqjbyoaa9vv'].length > 0
                    ? data['3ysepdqjbyoaa9vv'].map((el) => el.value).join('')
                    : ''
                }}
                {{ data.scb2igdb9zvhdqok || '' }}
              </span>
            </div>
          </div>
        </div>

        <!-- 详细信息卡片 -->
        <div class="info-card">
          <div class="card-header">
            <span class="accent-bar"></span>
            <h3 class="card-title">采购与科室明细</h3>
          </div>
          <div class="card-body">
            <div class="info-line">
              <span class="info-label">采购下单人：</span>
              <span class="info-val">
                {{
                  data.fnivxgmxe1bvqxol
                    ? data.fnivxgmxe1bvqxol.map((el) => el.value).join('/')
                    : '-'
                }}
              </span>
            </div>
            <div class="info-line">
              <span class="info-label">归属科室/部门：</span>
              <span class="info-val">
                {{
                  data.em9eprun6yuwfr7e && data.em9eprun6yuwfr7e.length > 0
                    ? data.em9eprun6yuwfr7e[0].map((el) => el.value).join('/')
                    : '-'
                }}
              </span>
            </div>
            <div class="info-line">
              <span class="info-label">采购备注说明：</span>
              <span class="info-val">{{ data.r2fzg7pqwr8czptv || '无特殊说明' }}</span>
            </div>
            <div class="info-line" v-if="data['3o5b1cmlyxziweqz']">
              <span class="info-label">总集对账备注：</span>
              <span class="info-val text-brand">{{ data['3o5b1cmlyxziweqz'] }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 商品清单明细表格卡片 -->
      <div class="goods-section-card">
        <div class="card-header">
          <div class="header-left">
            <span class="accent-bar"></span>
            <h3 class="card-title">采购商品明细清单</h3>
          </div>
          <span class="count-tag">共 {{ productList.length }} 项物资</span>
        </div>

        <div class="table-header-grid">
          <span class="col-goods">物资信息与规格</span>
          <span class="col-price" v-if="!type">协议单价</span>
          <span class="col-num">订购数量</span>
          <span class="col-total" v-if="!type">小计金额</span>
          <span class="col-aftersale" v-if="type">
            {{ type === 'returnGoods' ? '退货数量' : '换货数量' }}
          </span>
        </div>

        <ul class="goods-item-list">
          <li v-for="item in productList" :key="'item-' + item.id" class="goods-row-item">
            <div class="col-goods">
              <div class="thumb-wrap">
                <img
                  :src="
                    item['mnkt8dkjryhvdej3'] && item['mnkt8dkjryhvdej3'].length > 0
                      ? item['mnkt8dkjryhvdej3'][0].url
                      : ''
                  "
                  alt="商品图"
                  class="thumb-img"
                />
              </div>
              <div class="meta-box">
                <p class="title-text" v-if="item['whfmbyuc1i2pavi4'] && item['whfmbyuc1i2pavi4'].length > 0">
                  {{ item['whfmbyuc1i2pavi4'][0].value }}
                </p>
              </div>
            </div>

            <span class="col-price font-mono" v-if="!type">
              ¥ {{ formatMoney(item.rojkudmmvpzinpar) }}
            </span>

            <span class="col-num font-mono">
              {{ item.mcuilzaudpe3shlc }} {{ item.kq1qbbk7dulmlghs && !type ? `(${item.kq1qbbk7dulmlghs})` : '' }}
            </span>

            <span class="col-total font-mono" v-if="!type">
              ¥ {{ formatMoney(item.nvbfzg88gv88hnt9) }}
            </span>

            <!-- 退换货数量输入控制 -->
            <div class="col-aftersale" v-if="type">
              <el-input-number
                v-if="type === 'returnGoods'"
                v-model="item.mbvjcurb6r0ckynw"
                :min="0"
                :max="item.mcuilzaudpe3shlc"
                size="small"
                placeholder="数量"
              ></el-input-number>
              <el-input-number
                v-else
                v-model="item.me6d75ufdtk3amaq"
                :min="0"
                :max="item.mcuilzaudpe3shlc"
                size="small"
                placeholder="数量"
              ></el-input-number>
            </div>
          </li>
        </ul>

        <!-- 普通详情底部总计看板 -->
        <div class="detail-footer-bar" v-if="!type">
          <span class="tax-tag">含 13% 增值税专用发票随货同行 · 框架协议对公月结</span>
          <div class="total-wrap">
            <span class="label">订单应付总额：</span>
            <span class="amount font-mono">¥ {{ formatMoney(data.p6zxciihiw61mebe) }}</span>
          </div>
        </div>
      </div>

      <!-- 售后退换货表单（仅 type 存在时展现） -->
      <div class="aftersale-form-card" v-if="type">
        <div class="card-header">
          <span class="accent-bar"></span>
          <h3 class="card-title">售后物流与寄件信息</h3>
        </div>

        <el-form :model="form" label-width="100px" class="aftersale-form">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item :label="`${type === 'returnGoods' ? '退货' : '换货'}方式`" required>
                <el-select v-model="form.way" placeholder="请选择退换货方式" class="full-width">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="`${type === 'returnGoods' ? '退货' : '换货'}说明`" required>
                <el-input v-model="form.instructions" placeholder="请简要说明退换货原因"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <template v-if="form.way === 2">
            <div class="form-sub-header">总集退件收货地址（自行寄回目标地址）</div>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="收货人">
                  <el-select v-model="form.consignee" disabled placeholder="请选择" class="full-width">
                    <el-option
                      v-for="item in aggregateAddress"
                      :key="item.id"
                      :label="item.dg3wysizdducq39m"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式">
                  <el-input v-model="form.consigneePhone" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="收货地址">
                  <el-input v-model="form.consigneeAddress" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </template>

          <div class="form-sub-header">您的寄件地址信息</div>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="寄件人" required>
                <el-select v-model="form.sender" placeholder="请选择寄件地址" @change="changeAddress" class="full-width">
                  <el-option
                    v-for="item in myAddress"
                    :key="item.id"
                    :label="item.mdbcej4opshigmrs"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式">
                <el-input v-model="form.senderPhone" disabled placeholder="选择寄件人后自动带出"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="所在地区">
                <el-cascader
                  v-model="form.senderArea"
                  :options="city"
                  :props="props"
                  placeholder="请选择"
                  disabled
                  class="full-width"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="详细地址">
                <el-input v-model="form.senderAddress" disabled placeholder="选择寄件人后自动带出"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="submit-action-bar">
            <el-button type="primary" size="medium" @click="confirm" class="submit-aftersale-btn">
              确认提交{{ type === 'returnGoods' ? '退货' : '换货' }}申请
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { detailOnline, children, online, postOnline } from '@/api/platform';
import city from '@/util/city';

export default {
  name: "OrderDetail",
  props: {
    orderId: {
      type: [String, Number],
      default: '',
    },
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      id: '',
      data: {},
      type: '',
      productList: [],
      detailLoading: true,
      form: {
        way: '',
        instructions: '',
        consignee: '',
        consigneePhone: '',
        consigneeAddress: '',
        sender: '',
        senderPhone: '',
        senderArea: '',
        senderAddress: '',
      },
      options: [
        { value: 1, label: '上门取件' },
        { value: 2, label: '自行寄回' }
      ],
      aggregateAddress: [],
      myAddress: [],
      city,
      props: {
        label: 'name',
        value: 'id'
      }
    };
  },
  created () {
    this.id = this.orderId || this.$route.params.id;
    this.detailOnline();
    let type = this.$route.query.type;
    if (type) {
      this.type = type;
      this.getsAggregateAddress();
      this.getMyAddress();
    }
  },
  methods: {
    formatMoney (val) {
      if (val === null || val === undefined || val === '') return '0.00';
      const num = Number(val);
      return Number.isFinite(num) ? num.toFixed(2) : String(val);
    },
    async getsAggregateAddress () {
      try {
        const { result } = await online({
          form_head_uuid: '2fec51904d384887a819622a9975675b',
          page: 1,
          limit: 20
        });
        this.aggregateAddress = result || [];
        if (result && result.length > 0) {
          this.$set(this.form, 'consignee', result[0].id);
          this.$set(this.form, 'consigneePhone', result[0].lw5lmjwlsaz0vzuu);
          this.$set(this.form, 'consigneeAddress', result[0].fm0kblhuu2evs4rv);
        }
      } catch (e) {}
    },
    async getMyAddress () {
      try {
        const { result } = await online({
          form_head_uuid: '0f5b2fde26c04882a5d6c5c885a30a3f',
          page: 1,
          limit: 20,
          keyword: '',
          select_option: '',
        });
        this.myAddress = result || [];
      } catch (e) {}
    },
    changeAddress (e) {
      let obj = this.myAddress.find(el => el.id === e);
      if (!obj) return;
      this.$set(this.form, 'senderPhone', obj.xejhteu0ub3fd3eh);
      this.$set(this.form, 'senderArea', (obj.b3ccmzbfyzlwy9sc || []).map(el => el.id));
      this.$set(this.form, 'senderAddress', obj['9simp0sjii9s0m33']);
    },
    copyToClipboard () {
      const val = this.data['5rh34ajk852uufsx'];
      if (!val) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(val).then(() => {
          this.$message.success('订单编号已复制');
        }).catch(() => {
          this.fallbackCopy(val);
        });
      } else {
        this.fallbackCopy(val);
      }
    },
    fallbackCopy (text) {
      const oInput = document.createElement('input');
      oInput.value = text;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand('Copy');
      this.$message.success('订单编号已复制');
      oInput.remove();
    },
    async detailOnline () {
      this.detailLoading = true;
      try {
        const { result } = await detailOnline({
          form_head_uuid: "58a2be48484e436dbbb28fd778406de6",
          id: this.id,
        });
        this.data = result || {};
        await this.children();
      } catch (error) {
        this.data = {};
      } finally {
        this.detailLoading = false;
      }
    },
    async children () {
      try {
        const { result } = await children({
          page: 1,
          limit: 20,
          field_uuid: '00f98dceac054e8fb727092a99fc5a3d',
          form_head_uuid: '25a23d706f0e465c9ad89c333a841459',
          record_id: this.id
        });
        this.productList = result || [];
      } catch (error) {
        this.productList = [];
      }
    },
    async confirm () {
      let params = {};
      let form_head_uuid = '';
      const { productList, type, data: { id } } = this;
      const { way, instructions, sender, senderPhone, senderArea, senderAddress, consignee, consigneePhone, consigneeAddress } = this.form;
      if (!way) return this.$message.error(`请选择${type === 'returnGoods' ? '退' : '换'}货方式`);
      if (!instructions) return this.$message.error(`请输入${type === 'returnGoods' ? '退' : '换'}货说明`);
      if (!sender) return this.$message.error('请选择寄件人');

      if (this.type === 'returnGoods') {
        form_head_uuid = '30cfd060adfe11ee81ef0242321230b4';
        params = {
          irpxqkcdtusqiy2y: [id],
          indtkil4tvvff0ie: way === 1 ? '99152472-0949-4a28-89fc-61e8ddffaac3' : '4baade9e-2402-4ffd-9d57-74c1abc800cc',
          ky4zxdehqi6ofpap: instructions,
          hkfwaidbg4mywpks: [sender],
          tpqk8ilierx76okc: senderPhone,
          h4taz2eavvajozrm: senderArea,
          gw5nzk6ycd5osq1g: senderAddress,
          '5ei3icz5dttawswz': [consignee],
          d3q1oslyqeyggjei: consigneePhone,
          qc638rrzbxa1trrx: consigneeAddress,
          e7praxhjq8v5d8tr: productList.map(el => ({
            tlztdbj3bxchs5vi: (el.whfmbyuc1i2pavi4 || []).map(el => el.id),
            '6vxr6cjuplgkisse': el.mcuilzaudpe3shlc,
            mbvjcurb6r0ckynw: el.mbvjcurb6r0ckynw
          })),
        };
      } else {
        form_head_uuid = '01941b9eae0811ee879f0242321230b4';
        params = {
          a12n4mmhiv5zcziz: [id],
          indtkil4tvvff0ie: way === 1 ? '99152472-0949-4a28-89fc-61e8ddffaac3' : '4baade9e-2402-4ffd-9d57-74c1abc800cc',
          ky4zxdehqi6ofpap: instructions,
          edx2y56vqrptfdk8: [sender],
          twlzszggqs0hlzoj: senderPhone,
          lx6cxkbpuo6osmry: senderArea,
          rgxdenukluveemcq: senderAddress,
          ildcp7argfzmpygt: [consignee],
          axbtnlg6uvsm8ovd: consigneePhone,
          oa4tnu9d1wkvifsb: consigneeAddress,
          xixx4qsuefovkdiw: productList.map(el => ({
            tlztdbj3bxchs5vi: (el.whfmbyuc1i2pavi4 || []).map(el => el.id),
            '6vxr6cjuplgkisse': el.mcuilzaudpe3shlc,
            me6d75ufdtk3amaq: el.me6d75ufdtk3amaq
          })),
        };
      }
      try {
        await postOnline({
          form_head_uuid,
          ...params
        });
        this.$message({
          message: '售后申请提交成功',
          type: 'success'
        });
        setTimeout(() => {
          this.$router.go(-1);
        }, 1000);
      } catch (e) {
        this.$message.error('提交失败，请重试');
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/var.less';

.OrderDetail {
  padding: 16px 0 60px;

  // 1. 骨架屏
  .detail-skeleton {
    display: flex;
    flex-direction: column;
    gap: 16px;
    position: relative;
    overflow: hidden;

    .sk-header-card {
      height: 90px;
      background-color: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 10px;
    }

    .sk-info-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;

      .sk-card {
        height: 160px;
        background-color: #ffffff;
        border: 1px solid #e2e8f0;
        border-radius: 10px;
      }
    }

    .sk-table-card {
      height: 260px;
      background-color: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 10px;
    }
  }

  // 2. 顶部概览操作卡片
  .order-summary-header-card {
    background-color: #ffffff;
    border: 1px solid @brandBorder;
    border-radius: 10px;
    padding: 20px 24px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 40, 100, 0.03);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-main-info {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .title-row {
        display: flex;
        align-items: center;
        gap: 16px;

        .page-title {
          font-size: 18px;
          font-weight: 700;
          color: @brandTextDark;
        }

        .order-no-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background-color: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          padding: 3px 10px;
          font-size: 13px;

          .label {
            color: @brandTextLight;
          }

          .no {
            color: @brandPrimary;
            letter-spacing: 0.5px;
          }

          .copy-btn {
            background: none;
            border: none;
            color: @brandContainer;
            cursor: pointer;
            padding: 0 2px;
            font-size: 13px;

            &:hover {
              color: @brandPrimary;
            }
          }
        }

        .contract-badge {
          font-size: 12px;
          color: #10b981;
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-weight: 500;
        }
      }

      .sub-row {
        font-size: 12px;
        color: @brandTextLight;
      }
    }

    .header-action-zone {
      .back-link-btn {
        background-color: #f8fafc;
        border: 1px solid #cbd5e1;
        color: @brandTextDark;
        padding: 6px 14px;
        border-radius: 6px;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 6px;
        transition: all 0.15s ease;

        &:hover {
          color: @brandPrimary;
          border-color: @brandPrimary;
          background-color: #f0f5ff;
        }
      }
    }
  }

  // 3. 双栏信息卡片网格
  .info-cards-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;

    .info-card {
      background-color: #ffffff;
      border: 1px solid @brandBorder;
      border-radius: 10px;
      padding: 20px 24px;
      box-shadow: 0 2px 8px rgba(0, 40, 100, 0.02);

      .card-header {
        display: flex;
        align-items: center;
        gap: 8px;
        padding-bottom: 14px;
        margin-bottom: 14px;
        border-bottom: 1px solid #f1f5f9;

        .accent-bar {
          width: 3px;
          height: 15px;
          background-color: @brandPrimary;
          border-radius: 2px;
        }

        .card-title {
          font-size: 15px;
          font-weight: 700;
          color: @brandTextDark;
          margin: 0;
        }
      }

      .card-body {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .info-line {
          display: flex;
          font-size: 13px;
          line-height: 1.5;

          .info-label {
            width: 100px;
            color: @brandTextLight;
            flex-shrink: 0;
          }

          .info-val {
            color: @brandTextDark;

            &.bold {
              font-weight: 600;
            }

            &.text-brand {
              color: @brandPrimary;
              font-weight: 500;
            }
          }
        }
      }
    }
  }

  // 4. 物料明细卡片
  .goods-section-card {
    background-color: #ffffff;
    border: 1px solid @brandBorder;
    border-radius: 10px;
    padding: 20px 24px;
    box-shadow: 0 2px 8px rgba(0, 40, 100, 0.02);
    margin-bottom: 20px;

    .card-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 14px;
      margin-bottom: 14px;
      border-bottom: 1px solid #f1f5f9;

      .header-left {
        display: flex;
        align-items: center;
        gap: 8px;

        .accent-bar {
          width: 3px;
          height: 15px;
          background-color: @brandPrimary;
          border-radius: 2px;
        }

        .card-title {
          font-size: 15px;
          font-weight: 700;
          color: @brandTextDark;
          margin: 0;
        }
      }

      .count-tag {
        font-size: 12px;
        color: @brandTextLight;
      }
    }

    .table-header-grid {
      display: flex;
      align-items: center;
      height: 40px;
      background-color: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 6px;
      padding: 0 16px;
      font-size: 13px;
      font-weight: 600;
      color: @brandTextLight;
      margin-bottom: 8px;

      .col-goods { flex: 1; min-width: 320px; }
      .col-price { width: 140px; text-align: center; }
      .col-num { width: 130px; text-align: center; }
      .col-total { width: 140px; text-align: right; }
      .col-aftersale { width: 180px; text-align: center; }
    }

    .goods-item-list {
      list-style: none;
      padding: 0;
      margin: 0;

      .goods-row-item {
        display: flex;
        align-items: center;
        padding: 16px;
        border-bottom: 1px solid #f1f5f9;

        &:last-child {
          border-bottom: none;
        }

        .col-goods {
          flex: 1;
          min-width: 320px;
          display: flex;
          align-items: center;
          gap: 14px;

          .thumb-wrap {
            width: 60px;
            height: 60px;
            border: 1px solid #e2e8f0;
            border-radius: 6px;
            padding: 4px;
            background-color: #ffffff;
            flex-shrink: 0;

            .thumb-img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              mix-blend-mode: multiply;
            }
          }

          .meta-box {
            .title-text {
              font-size: 13px;
              font-weight: 600;
              color: @brandTextDark;
              line-height: 1.4;
              margin: 0;
            }
          }
        }

        .col-price {
          width: 140px;
          text-align: center;
          font-size: 13px;
          color: @brandTextDark;
        }

        .col-num {
          width: 130px;
          text-align: center;
          font-size: 13px;
          color: @brandTextLight;
        }

        .col-total {
          width: 140px;
          text-align: right;
          font-size: 14px;
          font-weight: 700;
          color: @brandPrimary;
        }

        .col-aftersale {
          width: 180px;
          display: flex;
          justify-content: center;
        }
      }
    }

    .detail-footer-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid #e2e8f0;
      padding: 16px 8px 0;
      margin-top: 8px;

      .tax-tag {
        font-size: 12px;
        color: #10b981;
        font-weight: 500;
      }

      .total-wrap {
        display: flex;
        align-items: baseline;
        gap: 6px;

        .label {
          font-size: 13px;
          color: @brandTextLight;
        }

        .amount {
          font-size: 22px;
          font-weight: 800;
          color: @brandPrimary;
        }
      }
    }
  }

  // 5. 售后退换货表单卡片
  .aftersale-form-card {
    background-color: #ffffff;
    border: 1px solid @brandBorder;
    border-radius: 10px;
    padding: 20px 24px;
    box-shadow: 0 2px 8px rgba(0, 40, 100, 0.02);

    .card-header {
      display: flex;
      align-items: center;
      gap: 8px;
      padding-bottom: 14px;
      margin-bottom: 16px;
      border-bottom: 1px solid #f1f5f9;

      .accent-bar {
        width: 3px;
        height: 15px;
        background-color: @brandPrimary;
        border-radius: 2px;
      }

      .card-title {
        font-size: 15px;
        font-weight: 700;
        color: @brandTextDark;
        margin: 0;
      }
    }

    .aftersale-form {
      .form-sub-header {
        font-size: 13px;
        font-weight: 600;
        color: @brandPrimary;
        margin: 16px 0 12px 10px;
        padding-left: 8px;
        border-left: 2px solid @brandPrimary;
      }

      .full-width {
        width: 100%;
      }

      .submit-action-bar {
        display: flex;
        justify-content: flex-end;
        padding-top: 20px;
        margin-top: 10px;
        border-top: 1px solid #f1f5f9;

        .submit-aftersale-btn {
          padding: 10px 28px;
          font-weight: 600;
        }
      }
    }
  }

  .skeleton-shimmer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(241, 245, 249, 0.75) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    transform: translateX(-100%);
    animation: shimmerMove 1.5s infinite;
    pointer-events: none;
    z-index: 2;
  }
}

.fade-in {
  animation: fadeIn 0.35s ease forwards;
}

@keyframes shimmerMove {
  100% {
    transform: translateX(100%);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/OrderDetail.vue